import { z } from 'zod'
import { LearningQuizQuestionType } from '@/core/domain/resources/enums/LearningQuizQuestion.ts'
import { QuizQuestionFeedbackSchema } from '@/core/infrastructure/schemas/quiz/QuizQuestionFeedbackSchema.ts'
import {
  QuizQuestionAnswerMatchingSchema,
  QuizQuestionAnswerSequencingSchema,
  QuizQuestionAnswerSingleChoiceSchema,
  QuizQuestionAnswerMultipleChoiceSchema,
  QuizQuestionAnswerTrueFalseSchema
} from '@/core/infrastructure/schemas/quiz/QuizQuestionAnswerSchema.ts'

const BaseQuestionSchema = z.object({
  id: z.number(),
  label: z.string(),
  order: z.number(),
  type: z.nativeEnum(LearningQuizQuestionType.Values),
  feedbacks: QuizQuestionFeedbackSchema
})

// Définition spécifique pour chaque type de question avec leurs réponses fortement typées
export const QuizQuestionSingleChoiceSchema = BaseQuestionSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.SINGLE_CHOICE),
  answers: z.array(QuizQuestionAnswerSingleChoiceSchema)
})

export const QuizQuestionMultipleChoiceSchema = BaseQuestionSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.MULTIPLE_CHOICE),
  answers: z.array(QuizQuestionAnswerMultipleChoiceSchema)
})

export const QuizQuestionTrueFalseSchema = BaseQuestionSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.TRUE_FALSE),
  answers: z.array(QuizQuestionAnswerTrueFalseSchema)
})

export const QuizQuestionMatchingSchema = BaseQuestionSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.MATCHING),
  answers: z.array(QuizQuestionAnswerMatchingSchema)
})

export const QuizQuestionSequencingSchema = BaseQuestionSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.SEQUENCING),
  answers: z.array(QuizQuestionAnswerSequencingSchema)
})

// Question schema avec union discriminée
export const LearningQuestionSchema = z.discriminatedUnion('type', [
  QuizQuestionSingleChoiceSchema,
  QuizQuestionMultipleChoiceSchema,
  QuizQuestionTrueFalseSchema,
  QuizQuestionMatchingSchema,
  QuizQuestionSequencingSchema
])
export const LearningQuestionListSchema = z.array(LearningQuestionSchema)

export const QuestionListSchema = z.array(LearningQuestionSchema)

export type LearningQuestionEntity = z.infer<typeof LearningQuestionSchema>
export type LearningQuestionSingleChoiceEntity = z.infer<typeof QuizQuestionSingleChoiceSchema>
export type LearningQuestionMultipleChoiceEntity = z.infer<typeof QuizQuestionMultipleChoiceSchema>
export type LearningQuestionTrueFalseEntity = z.infer<typeof QuizQuestionTrueFalseSchema>
export type LearningQuestionMatchingEntity = z.infer<typeof QuizQuestionMatchingSchema>
export type LearningQuestionSequencingEntity = z.infer<typeof QuizQuestionSequencingSchema>
export type LearningQuestionListEntity = z.infer<typeof QuestionListSchema>
